import { GetterTree } from "vuex";
import { RecipesState, RootState } from "@/types/recipes";

const getters: GetterTree<RecipesState, RootState> = {
  getRecipeDetail: (state: RecipesState) => {
    return state.detailInfo;
  },
  getRecentMyList: (state: RecipesState) => {
    return state.recentMyList;
  },
  getFolderList: (state: RecipesState) => {
    return state.folderList;
  },
  getAddRecipeMyList: (state: RecipesState) => {
    return state.addRecipeResult;
  },
  getDeleteRecipeMyList: (state: RecipesState) => {
    return state.deleteRecipeResult;
  }
}

export default getters;
